import React, { createContext, useContext, useCallback, useState } from 'react';

interface UserProfileRefreshContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
}

const UserProfileRefreshContext = createContext<UserProfileRefreshContextType | undefined>(undefined);

export function UserProfileRefreshProvider({ children }: { children: React.ReactNode }) {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = useCallback(() => {
    console.log('[UserProfileRefreshContext] Triggering profile refresh');
    setRefreshTrigger(prev => prev + 1);
  }, []);

  return (
    <UserProfileRefreshContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </UserProfileRefreshContext.Provider>
  );
}

export function useUserProfileRefresh() {
  const context = useContext(UserProfileRefreshContext);
  if (context === undefined) {
    throw new Error('useUserProfileRefresh must be used within a UserProfileRefreshProvider');
  }
  return context;
}
